const fields = `
  playerCount
  potAmount
`;

export const gameStatsFields = `
  ... on FalkorGame {
    stats {
      ${fields}
    }
  }
`;

const gameStat = (game, field) => (game?.stats || game || {})[field];

export const gamePlayerCount = (game) => gameStat(game, 'playerCount');

export const gamePotAmount = (game) => gameStat(game, 'potAmount');
